export const USER_TYPES = {
    ADMIN:1,
    
}

export const REGISTRATION_STEPS = {
    PHONENUMBER_REQUEST:1,
    SMS_REQUEST:2,
    CASINO_PIN:3,
    TERMS_CONDITION:4,
    USER_FORM:5,
    SUCCESS:6,
    FAIL:-1
}